import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { SBAsyncSelect } from '@supplement-bacon/react-async-select'
import { initialQuery } from '@supplement-bacon/sb-table-filters'
import { SBRMFormActionProps } from '@supplement-bacon/sbrm-react'
import { Entity } from '@utils/Entities'
import { requiredRule, stringRule } from '@utils/rules'
import {
  Button,
  Card,
  Collapse,
  CollapseProps,
  DatePicker,
  Flex,
  Form,
  Input,
  Space,
  Typography,
} from 'antd'
import TextArea from 'antd/es/input/TextArea'

const { Text } = Typography

const Create = ({ form, formProps }: SBRMFormActionProps) => {
  const items: CollapseProps['items'] = [
    {
      key: '1',
      label: 'Informations générales',
      children: (
        <Flex vertical>
          <Form.Item
            name="name"
            label={'Nom de la campagne'}
            rules={[requiredRule(), stringRule()]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="start"
            label={'Date de début'}
            rules={[requiredRule()]}
          >
            <DatePicker className="w-full" />
          </Form.Item>
          <Form.Item
            name="softEnd"
            label={'Date de fin visible'}
            rules={[requiredRule()]}
          >
            <DatePicker className="w-full" />
          </Form.Item>
          <Form.Item
            name="hardEnd"
            label={'Date de fin réelle'}
            rules={[requiredRule()]}
          >
            <DatePicker className="w-full" />
          </Form.Item>
        </Flex>
      ),
    },
    {
      key: '2',
      label: 'Formulaires',
      children: (
        <Flex vertical>
          <Form.List name="formsAssociation">
            {(fields, { add, remove }) => (
              <Flex vertical gap={16}>
                {fields.map(({ key, name, ...restField }) => (
                  <Card
                    key={key}
                    variant="outlined"
                    styles={{ body: { padding: 10 } }}
                  >
                    <Space
                      className="w-full space-between"
                      style={{ marginBottom: 10 }}
                    >
                      <Text type="secondary">Association</Text>
                      <DeleteOutlined
                        style={{ color: 'red' }}
                        onClick={() => remove(name)}
                      />
                    </Space>

                    <Flex gap={16} align="baseline" className="w-full">
                      <Form.Item
                        label={'Formulaire'}
                        name={[name, 'form']}
                        rules={[requiredRule()]}
                        className="w-full m-0"
                        {...restField}
                      >
                        <SBAsyncSelect entity={Entity.form} size="middle" />
                      </Form.Item>
                      <Form.Item
                        name={[name, 'jobs']}
                        rules={[requiredRule()]}
                        label={'Poste'}
                        {...restField}
                        className="w-full m-0"
                      >
                        <SBAsyncSelect
                          multiple
                          entity={Entity.job}
                          size="middle"
                          initialQuery={{
                            ...initialQuery,
                            pagination: {
                              current: 1,
                              pageSize: 1000,
                            },
                          }}
                        />
                      </Form.Item>
                    </Flex>
                  </Card>
                ))}
                <Form.Item>
                  <Button
                    type="dashed"
                    onClick={() => add()}
                    block
                    icon={<PlusOutlined />}
                    className="w-full"
                  >
                    Ajouter un formulaire
                  </Button>
                </Form.Item>
              </Flex>
            )}
          </Form.List>
        </Flex>
      ),
    },
    {
      key: '3',
      label: 'Contenu du mail envoyé à chaque employé',
      children: (
        <Flex vertical>
          <Form.Item
            name="mailSubject"
            label={'Objet du mail'}
            rules={[requiredRule(), stringRule()]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="mailBody"
            label={'Corps du mail'}
            rules={[requiredRule()]}
          >
            <TextArea rows={6} />
          </Form.Item>
        </Flex>
      ),
    },
  ]

  return (
    <Form {...formProps} form={form} layout="vertical">
      <Collapse accordion items={items} defaultActiveKey={['1']} />
    </Form>
  )
}

export default Create
